import script from "./BookingCancelSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingCancelSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./BookingCancelSuccess.vue?vue&type=style&index=0&id=ed7d742c&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed7d742c"]])

export default __exports__